import * as React from 'react';
import { bem, classnames, use } from '../../lib';
/**
 * HeaderStart component
 *
 * @visibleName HeaderStart
 */
const HeaderStartComponent = ({ children, className, notFixed }) => {
    return (React.createElement("div", { className: classnames(className, bem('header__left-wrapper', use(notFixed, '--not-fixed'))) }, children));
};
export const HeaderStart = HeaderStartComponent;
//# sourceMappingURL=HeaderStart.js.map